import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacyPolicyPage: React.FC = () => (
  <>
    <Container maxWidth="md" sx={{ pt: 6, pb: 8 }}>
      <Box>
        <Typography variant="h2" sx={{ mb: 2 }}>
          Datenschutzerklärung
        </Typography>
        {/* Social Media Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Social Media
          </Typography>
          <Typography component="div" sx={{ mb: 1 }}>
            Folgen Sie uns auf:
            <br />
            <a
              href="https://www.facebook.com/wuerttembergdartliga"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
            {" | "}
            <a
              href="https://www.instagram.com/wuerttembergdartliga"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Hinweis: Beim Verlassen dieser Website und dem Besuch unserer
            Social-Media-Seiten (z.B. Facebook, Instagram) gelten die
            Datenschutzbestimmungen und Nutzungsbedingungen der jeweiligen
            Plattformen. Wir übernehmen keine rechtliche Verantwortung für die
            Inhalte, den Datenschutz oder das Tracking auf externen Seiten. Es
            kann sein, dass beim Besuch dieser Plattformen personenbezogene
            Daten (wie IP-Adresse, Nutzungsverhalten, etc.) durch die Betreiber
            erfasst, ausgewertet und gespeichert werden. Bitte informieren Sie
            sich direkt bei den jeweiligen Anbietern über deren
            Datenschutzrichtlinien.
          </Typography>
        </Box>
        <Typography component="div" sx={{ mb: 1 }}>
          Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
          Personenbezogene Daten werden auf dieser Website nur im technisch
          notwendigen Umfang erhoben. In keinem Fall werden die erhobenen Daten
          verkauft oder aus anderen Gründen an Dritte weitergegeben.
          <br />
          <br />
          <strong>Verantwortliche Stelle:</strong>
          <br />
          WBL Dartliga, Ferdinand Schneider, wuerttemberg-dart-liga@gmx.de
          <br />
          <br />
          <strong>Erhebung und Verarbeitung von Daten:</strong>
          <br />
          Beim Besuch dieser Website speichern die Webserver standardmäßig
          technische Zugriffsdaten, wie die IP-Adresse Ihres Internet Service
          Providers, die Website, von der aus Sie uns besuchen, die Webseiten,
          die Sie bei uns besuchen, sowie das Datum und die Dauer des Besuches.
          Diese Informationen sind für die technische Übertragung der Webseiten
          und den sicheren Serverbetrieb zwingend erforderlich. Eine
          personalisierte Auswertung dieser Daten erfolgt nicht.
          <br />
          <br />
          <strong>Ihre Rechte:</strong>
          <br />
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung und
          Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Bei
          Fragen wenden Sie sich bitte an wuerttemberg-dart-liga@gmx.de.
        </Typography>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Google Maps
          </Typography>
          <Typography component="div" sx={{ mb: 1 }}>
            Diese Website verwendet Google Maps zur Darstellung von Standorten
            und zur besseren Orientierung. Beim Aufruf von Seiten mit
            eingebetteten Google Maps können Informationen (wie Ihre IP-Adresse
            und ggf. weitere Nutzungsdaten) an Server von Google übertragen und
            dort gespeichert werden. Wir haben keinen Einfluss auf die
            Datenübertragung und -verarbeitung durch Google. Bitte beachten Sie
            die{" "}
            <a
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              Datenschutzerklärung von Google
            </a>{" "}
            für weitere Informationen.
            <br />
            <br />
            Wir übernehmen keine Verantwortung für die Verarbeitung, Speicherung
            oder Nutzung Ihrer Daten durch Google. Die Nutzung von Google Maps
            erfolgt in Ihrer eigenen Verantwortung.
          </Typography>
        </Box>
      </Box>
    </Container>
  </>
);

export default PrivacyPolicyPage;
